import {getMemoryListProvider} from 'views/programming/channel/contexts/getMemoryListProvider';
import {useFindLibraryQuery} from 'features/channelCatalog/channelCatalogApi';

export const {MemoryListContext, MemoryListProvider, useMemoryListProvider} =
  getMemoryListProvider(useFindLibraryQuery);
